module.exports = __webpack_public_path__ + "img/brad-pro.e080dd7e.jpg";